<template>
    <div class="bg-dim flex-col">
        <div class="safe-area absolute">
            <div class="popup-wrap">
                <div class="stopusing-detail-top">
<!--                    <span class="cake-center shadow"></span>-->
<!--                    <img :src="data.imageName" />-->
                    <span class="card-image-border-none" :style="{ backgroundImage:'url('+data.imageName+')'}"></span>
                    <div>
                        <em>{{data.price | comma}}</em>
                        <strong>{{data.text}}</strong>
                        <span>구매일<small>{{data.firstDate}}</small></span>
                    </div>
                </div>
                <div class="line-box">
                    <div class="gray-line"></div>
                </div>
                <div class="popup-textbox">
                    <span>{{year}}년 {{month}}월 {{day}}일에 {{data.text}} 된 {{data.price | comma}}원을</span>
                    <span>취소 하시겠습니까?</span>
                </div>
            </div>
            <div class="button-wrap">
              <button class="button-bg-gray" @click.prevent="chargeCancelButton(false)">아니요</button>
              <button class="button-bg-yellow" @click.prevent="chargeCancelButton(true)">예</button>
            </div>
        </div>
    </div>
</template>

<script>
import dayjs from "dayjs";
import apiList from "@/api/apiList";
export default {
  name: 'MyDetailChargeCancelPopup',
  props: ["data"],
  data() {
    return  {
      year: '',
      month: '',
      day: ''

    }
  },
  filters: {
    comma(num) {
      return String(num).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted(){
    this.dateFormat(this.data.firstDate);
  },
  methods : {
    dateFormat(date) {
        const yyyymmdd = dayjs(date);

        this.year = yyyymmdd.get("y");
        this.month = yyyymmdd.get("M") + 1;
        this.day = yyyymmdd.get("D");
    },
    async chargeCancelButton(check) {
      if(check) {

        const param = this.data;

        try {
          const response = await apiList.putReloadCancelCash(param); //충전취소 API

          if (response.data.code === 'S00000') { //충전취소 성공
            this.$emit("charge-popup", [param, false]);
          } else {
            param.error = true;
            this.$emit("charge-popup", [param, false]);
          }
        } catch (error) {
          param.error = true;
          this.$emit("charge-popup", [param, false]);
        }
      } else { //충전취소 -> 취소
        this.$emit("charge-popup", [null, false]);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
	@import '@/assets/styles/pages/myemarticon/emarticonPaymentVoidPopup.scss';
</style>